export const OccupationRemark = {
  PURCHASE_OFFICER: 'poRemarks',
  PROCUREMENT_MANAGER: 'pmRemarks',
  TECHNICAL_REMARK: 'technicalRemarks',
  COMMERCIAL_MANAGER: 'cmRemarks',
};

export type VendorRemarkOccupation =
  | 'Purchase Officer'
  | 'Procurement Manager'
  | 'Procurement Team Lead'
  | 'Technical'
  | 'Commercial Manager'
  | 'Commercial Director';

export interface VendorRemark {
  name: string;
  value: string;
  date: string;
  occupation: VendorRemarkOccupation;
}

export enum TenderVendorRecommendationType {
  PURCHASE_OFFICER = 'PURCHASE_OFFICER',
  PROCUREMENT_MANAGER = 'PROCUREMENT_MANAGER',
  PROCUREMENT_TEAM_LEAD = 'PROCUREMENT_TEAM_LEAD',
  COMMERCIAL_DIRECTOR = 'COMMERCIAL_DIRECTOR',
  TECHNICAL = 'TECHNICAL',
  COMMERCIAL_MANAGER = 'COMMERCIAL_MANAGER',
}

export const TenderVendorRecommedationOccupation: Record<
  TenderVendorRecommendationType,
  VendorRemarkOccupation
> = {
  [TenderVendorRecommendationType.PURCHASE_OFFICER]: 'Purchase Officer',
  [TenderVendorRecommendationType.PROCUREMENT_MANAGER]: 'Procurement Manager',
  [TenderVendorRecommendationType.PROCUREMENT_TEAM_LEAD]:
    'Procurement Team Lead',
  [TenderVendorRecommendationType.TECHNICAL]: 'Technical',
  [TenderVendorRecommendationType.COMMERCIAL_MANAGER]: 'Commercial Manager',
  [TenderVendorRecommendationType.COMMERCIAL_DIRECTOR]: 'Commercial Director',
};
